import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=44f04226&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f04226",
  null
  
)

export default component.exports